export default __webpack_public_path__ + "static/media/uefaeq.2f06a4f8.png";